(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["category-tile"] && !Shopify.designMode) return;
  try {
    (function () {
    // Shared across every category-tile instance on the page (Shopify
    // dedupes identical javascript blocks by content). Swaps in the
    // deferred crossfade photos once the browser is idle, well ahead of
    // when the CSS rotation actually needs them.
    var loadDeferredTilePhotos = function () {
      document.querySelectorAll('.category-tile__photo[data-src]').forEach(function (img) {
        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
      });
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadDeferredTilePhotos, { timeout: 3000 });
    } else {
      window.addEventListener('load', function () {
        setTimeout(loadDeferredTilePhotos, 0);
      }, { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
